import React from 'react';
import { Box, Card, CardContent, Typography, Alert } from '@mui/material';

const JTIExportDataView = () => {
  return (
    <Box sx={{ p: 3, maxWidth: 900, mx: 'auto' }}>
      <Typography variant="h4" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
       
        Exports & Reports
      </Typography>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Use this page to access exports and reports once they are available.
      </Typography>

      <Card>
        <CardContent>
          <Alert severity="info">
            To be implemented.
          </Alert>
        </CardContent>
      </Card>
    </Box>
  );
};

export default JTIExportDataView;
